<template>
  <div :id="gateNumber">
    <h3>Schedule for gate {{ gateNumber }}</h3>
    <!-- <p>There are no scheduled water orders.</p> -->
    <ul>
      <li v-for="week in getGateCalendar(gateNumber)" :key="week.label">
        <router-link :to="pageLink(week.id)">
        {{ week.label }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  inject: ['gateData'],
  props: ['gate'],
  data() {
    return {
      gateNumber: this.gate,
      gates: this.gateData
    }
  },
  methods: {
    getGateCalendar(gateNum) {
      const targetGate = this.gates.find(theGate => theGate.gate === gateNum );
      return targetGate.gateCalendar;
    },
    pageLink(theID) {
      return '/schedules/' + theID;
    }
  }
}
</script>

<style>

</style>